import { render, staticRenderFns } from "./AbaSocietarioOportunidade.vue?vue&type=template&id=1cc05c45"
import script from "./AbaSocietarioOportunidade.vue?vue&type=script&lang=js"
export * from "./AbaSocietarioOportunidade.vue?vue&type=script&lang=js"
import style0 from "./AbaSocietarioOportunidade.vue?vue&type=style&index=0&id=1cc05c45&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports